import $ from 'jquery';

export async function ensureUnobtrusiveValidation() {
    if (!$?.validator?.unobtrusive?.parse) {
        await import('./unobtrusive');
    }
}

export function clearErrors($form) {
    if ($form.valid()) {
        return;
    }

    $form.data('validator').resetForm();
    $form
        .find('.validation-summary-errors')
        .removeClass('validation-summary-errors')
        .addClass('validation-summary-valid');
}

export function parseDynamicFormElements($form) {
    if (!$form || !$form.length) {
        return;
    }

    $form
        .removeData('validator') /* added by the raw jquery.validate plugin */
        .removeData('unobtrusiveValidation'); /* added by the jquery unobtrusive plugin*/

    $.validator.setDefaults({
        ignore: []
    });
    $.validator.unobtrusive.parse($form);
}

export function isDynamicFormValid($form) {
    if (!$form || !$form.length) {
        return false;
    }

    parseDynamicFormElements($form);

    return $form.valid();
}

export function isValidShipDate(inputDate) {
    const shipDate = new Date(inputDate);
    const todaysDate = new Date();
    const sunday = 0;
    const saturday = 6;
    const maxYearThreshold = 5;

    shipDate.setHours(0, 0, 0, 0);
    todaysDate.setHours(0, 0, 0, 0);

    if (new RegExp(`${saturday}|${sunday}`).test(shipDate.getDay())) {
        return false;
    }

    if (shipDate.getFullYear() - todaysDate.getFullYear() > maxYearThreshold) {
        return false;
    }

    return shipDate >= todaysDate;
}

export async function wrapUnobtrusiveValidationForm($formElement) {
    const $form = ensurejQueryElement($formElement);

    await ensureUnobtrusiveValidation();

    parseDynamicFormElements($form);

    return {
        valid: () => $form.valid(),
        clear: () => clearErrors($form)
    };
}

function ensurejQueryElement($element) {
    return $element.jQuery ? $element : $($element);
}
